import UIStepIndicator from 'UIComponents/connectedStep/UIStepIndicator';
import ApprovalUnifiedEventDisplay from './ApprovalUnifiedEventDisplay';
import ApprovalUnifiedEventIcon from './ApprovalUnifiedEventIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ApprovalUnifiedEventsList(props) {
  const {
    events
  } = props;
  const CustomStepIcon = ({
    index,
    defaultIcon
  }) => {
    const event = events[index];
    return /*#__PURE__*/_jsx(ApprovalUnifiedEventIcon, {
      event: event,
      defaultIcon: defaultIcon
    });
  };
  return /*#__PURE__*/_jsx(UIStepIndicator, {
    direction: "vertical",
    stepIndex: 0,
    stepNames: events.map(event => /*#__PURE__*/_jsx(ApprovalUnifiedEventDisplay, {
      event: event
    }, event.idempotencyId)),
    StepIconComponent: CustomStepIcon
  });
}